import { apiUrl } from "utils/urls";

import axios from "axios";

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");

    if (token) {
        config.headers["Authorization"] = `Token ${token}`;
    } else {
        delete config.headers["Authorization"];
    }
    return config;
});

export const loginApi = async (body) => {
    const { data } = await axios.post(apiUrl("login"), body);
    return data;
};

export const logout = async () => {
    const { data } = await axios.post(apiUrl("logout"));
    return data;
};

export const signUpApi = async (body) => {
    const { data } = await axios.post(apiUrl("signup"), body);
    return data;
};

export const googleLoginApi = async (body) => {
    const { data } = await axios.post(apiUrl("googleLogin"), body);
    return data;
};

export const googleRegisterApi = async (body) => {
    const { data } = await axios.patch(apiUrl("googleLogin"), body);
    return data;
};

export const naverLoginApi = async (body) => {
    const { data } = await axios.post(apiUrl("naverLogin"), body);
    return data;
};

export const naverRegisterApi = async (body) => {
    const { data } = await axios.post(apiUrl("naverLogin"), body);
    return data;
};

export const postOverleafSsoToken = async (body) => {
    const { data } = await axios.post(apiUrl("overleafSsoToken"), body);
    return data;
};

export const sendEmailConfirmApi = async (body) => {
    const res = await axios.post(apiUrl("emailConfirm"), body);
    return res;
};

export const verifyEmailConfirmApi = async (params) => {
    const res = await axios.get(apiUrl("emailConfirm"), { params });
    return res;
};

export const userCheck = async (space_uuid) => {
    const { data } = await axios.get(apiUrl("user") + "/check", {
        params: space_uuid ? { space_uuid: space_uuid } : undefined,
    });
    return data;
};

export const adminChangeUser = async (body) => {
    const { data } = await axios.post(apiUrl("adminChangeUser"), body);
    return data;
};

export const getExitSurvey = async (body) => {
    const { data } = await axios.get(apiUrl("exitSurvey"));
    return data;
};
